import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'

export default async function resetConvoForm(context: BareActionContext<ConvoState, RootState>)
{
    convoStore.commitResetConvoForm({})

    return
}
